import { computed } from '@vue/composition-api'
import Map from '@/components/Map/Map'
import useInstances from '@/compositions/useInstances'

export default ({
  name: 'Home',
  components: { Map },
  setup(props, context) {
    const { $store } = context.root
    const { instances } = useInstances(context)
    const activeInstances = computed(() => instances.value.filter(instance => instance.state === 'active'))
    return {
      user: computed(() => $store.state.auth.user),
      ids: computed(() => activeInstances.value.map(instance => instance.wialonId)),
    }
  },
})
